import { NumberInput, maxValue, minValue, useRecordContext } from "react-admin";
import { Grid } from "@mui/material";
import { MIN_ADMISSION_YEAR, deriveCurrentAdmissionYear, getMaxAdmissionYear } from "../utils";

/**
 * The cohort a saved plan prices. Defaults to the year of the plan currently loaded, so re-saving prices keeps
 * the same cohort; typing an older year stores a historical plan and leaves the current one in place.
 */
const AdmissionYearInput = ({ disabled }) => {
  const record = useRecordContext();
  const maxYear = getMaxAdmissionYear();

  return (
    <Grid
      item
      xs={12}
      md={4}
    >
      <NumberInput
        source="admissionYear"
        label="Година на прием"
        helperText="Годината, в която започва учебната година на приема (2024 = випуск 2024/2025). По-стара година се запазва като исторически план и не заменя текущия."
        defaultValue={deriveCurrentAdmissionYear(record)}
        disabled={disabled}
        min={MIN_ADMISSION_YEAR}
        max={maxYear}
        validate={[minValue(MIN_ADMISSION_YEAR), maxValue(maxYear)]}
        onWheel={e => e.target.blur()}
        fullWidth
      />
    </Grid>
  );
};

export default AdmissionYearInput;
